module.exports = "pegasus/assets/complex_library_block.png";